import React__default from 'react';
import classNames from 'classnames';

const AspectRatio = (props) => {
    const { className, children, ratio = '', portrait = false, rounded = false, bgColor = false, tag = 'div' } = props;
    const Tag = tag;
    const classNames$1 = classNames('aspect-ratio', !!ratio && `aspect-ratio--${ratio} aspect-ratio--absolute`, { 'aspect-ratio--portrait': portrait }, { 'aspect-ratio--rounded': rounded }, { 'aspect-ratio--bg-color': bgColor }, className);
    return (React__default.createElement(Tag, { className: classNames$1 }, children));
};

export { AspectRatio };
//# sourceMappingURL=AspectRatio.js.map
